import { render, staticRenderFns } from "./playVideo.vue?vue&type=template&id=7891754a&"
import script from "./playVideo.vue?vue&type=script&lang=js&"
export * from "./playVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports